<template>
    <div class="message-next">
        <div class="d-flex justify-content-between">
            <div class="message">
                <!--<p><b>ALERT:</b> Sono stati selezionati aereoporti di parteza e di arrivo differenti</p>-->
            </div>
            <div class="buttons">
                <a href="#">click</a>
                <button class="btn btn-outline-secondary" @click="onClick">PROCEDI</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MessageNext',
  props: {
    scrollTo: {
      type: String,
      default: 'app'
    }
  },
  methods: {
    onClick () {
      this.$emit('click')
      this.$scrollTo('#' + this.scrollTo)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/MessageNext.vue